import React from 'react';

// Rendered outside every provider (store, router, theme), so it must not depend on any of them.
const ErrorFallback: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f2f5',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '3em', marginBottom: '0.5em' }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: '1.5em', maxWidth: '600px', textAlign: 'center' }}>
        An unexpected error occurred. Please reload the page to continue.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{ fontSize: '1.2em', padding: '8px 24px', cursor: 'pointer' }}
      >
        Reload
      </button>
    </div>
  );
};

export default ErrorFallback;
